import { Component, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "crew-confirm",
    template: require('./confirm-dialog.component.html')
})
export class ConfirmDialog {
    constructor(public dialogRef: MatDialogRef<boolean>) {
        // default
        this.content = "Are you sure?";
    }

    @Input()
    content: string;

    yes() {
        this.dialogRef.close(true);
    }

    no() {
        this.dialogRef.close(false);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/confirm-dialog.component.ts